import  usePartnerNew from './usePartnerNew';
export default usePartnerNew
